import React from "react";
import "./AboutUsStyle.scss";
import { aboutUsTextContent } from "./constant/index";
import SectionHeading from "../Common_UI_Kit/SectionHeading";

const AboutUsSection = () => {
  return (
    <section className="about-us-section">
      <div className="about-us-wrap">
        <SectionHeading>{aboutUsTextContent.headingText}</SectionHeading>

        <div className="about-us-box">
          <p className="para-text">{aboutUsTextContent.paraText}</p>

          <div className="about-us-container">
            <div className="img-box">
              <img src={aboutUsTextContent.imageSrc} alt="Images" />
            </div>

            <div className="text-box">
              <div className="text-box-inner">
                {aboutUsTextContent.content.map((section, index) =>
                  section.listContent && section.listContent.length > 0 ? (
                    <ul className="list-text-box" key={index}>
                      {section.listContent.map((item, itemIndex) => (
                        <li className="list-text" key={itemIndex}>
                          {item.listText}
                        </li>
                      ))}
                    </ul>
                  ) : null
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsSection;
